import styled from 'styled-components'
import { default as VARIABLES } from '../../themes/styles/variables'

// Wrapper
// ============================================================
export const AnnouncementManagementStyled = styled.div`
  /* Parent styles
  ------------------------------- */
  width: 100%;

  /* Child element styles
  ------------------------------- */
  /* .main-content {
    min-width: 1600px;
  } */

  .table-wrapper {
    margin-top: 21px;
  }

  .table {
    .table-row {
      .order-number {
        flex: 0 0 9%;
        justify-content: center;
        text-align: center;
      }

      .title {
        flex: 1 1 auto;
      }

      .start-date {
        flex: 0 0 16%;
        justify-content: center;
        text-align: center;
      }

      .end-date {
        flex: 0 0 16%;
        justify-content: center;
        text-align: center;
      }

      .last-update {
        flex: 0 0 16%;
        justify-content: center;
        text-align: center;
      }

      .actions {
        flex: 0 0 10%;
        & > .section {
          justify-content: center;
        }
      }

      .table-column {
        &.actions {
          padding-left: 15px;
        }
      }
    }
  }

  /* Modifiers
  ------------------------------- */

  /* Media queries
  ------------------------------- */
`
